var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 118,
    viewBox: "0 0 71 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.82887 108.108C2.69706 107.603 1.9925 106.457 2.00006 105.21L2.17623 76.1613C2.27325 60.1635 16.2114 47.2791 33.3081 47.3838L37.4356 47.4092C52.1595 47.9281 53.9585 66.4605 54.9579 65.4533C55.9574 64.446 55.4647 46.1753 55.5576 44.3021C55.6505 42.4289 65.323 41.8247 65.7519 43.8992C66.1807 45.9738 66.7513 56.3886 64.3527 65.4533C61.954 74.5179 57.7564 77.5395 54.9579 77.5395C52.1595 77.5395 51.1601 74.7193 50.7603 73.7121C50.3605 72.7049 50.7019 70.892 49.3611 70.892C48.3616 70.892 48.5663 72.3077 48.5615 73.1078V110.216C48.5615 111.138 47.9407 111.945 47.0497 112.155C41.9687 113.352 36.8861 114.033 31.3562 113.999C27.3361 113.974 23.7702 113.609 20.0482 112.932C19.1066 112.76 18.4343 111.924 18.4404 110.96L18.6577 76.5658C18.6633 75.6328 17.6194 74.8713 16.6221 74.8653C15.6248 74.8588 14.5717 75.6106 14.566 76.5437L14.3594 109.204C14.3511 110.515 13.1211 111.47 11.8742 111.095C9.1068 110.264 6.42044 109.264 3.82887 108.108Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.4642 20.6603C52.3557 31.6951 44.3258 41.2528 33.5285 42.0081C22.7313 42.7631 12.7396 34.4269 11.8479 23.3921C10.9562 12.3573 19.5022 2.80276 30.2994 2.04754C41.0966 1.29231 50.5723 9.62554 51.4642 20.6603Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 34.5756C28.7042 35.9001 31.2422 36.7041 32.3599 36.6762C33.5613 36.6461 35.1504 36.6762 37.1504 35.5613",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_433",
    x: 0,
    y: 0,
    width: 70.1367,
    height: 118,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_433"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_433",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcome);
export default __webpack_public_path__ + "static/media/welcome.fdeb4102e235e5929cfd1d66b8b1bbb9.svg";
export { ForwardRef as ReactComponent };